import { render, staticRenderFns } from "./FreedomCompete.vue?vue&type=template&id=2a1b2709&scoped=true&"
import script from "./FreedomCompete.vue?vue&type=script&lang=js&"
export * from "./FreedomCompete.vue?vue&type=script&lang=js&"
import style0 from "./FreedomCompete.vue?vue&type=style&index=0&id=2a1b2709&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b2709",
  null
  
)

export default component.exports